import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/MoreProjectsQuery.graphql';
import type { ExtraProps } from './types.tsx';

type EntryPointParams = { cloudId: string } & ExtraProps;
export const MoreProjectsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-more-projects-flyout" */ './MoreProjects.tsx').then(
			({ MoreProjects }) => MoreProjects,
		),
	),
	getPreloadProps: ({ cloudId }: EntryPointParams) => ({
		queries: {
			moreProjects: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: { cloudId },
			},
		},
		extraProps: {},
	}),
});
